<template>
    <div>
        トップページの情報
    </div>
</template>

<script>
export default {
    name: 'Top'
}
</script>



// WEBPACK FOOTER //
// src/pages/Top.vue